"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const CardStyles_1 = require("../card/CardStyles");
require("./BookAgain.scss");
const BookAgain = () => (react_1.default.createElement("div", { className: "BookAgain" },
    react_1.default.createElement(CardStyles_1.Title, null, "Reservar novamente"),
    react_1.default.createElement("span", null, "Voc\u00EA s\u00F3 poder\u00E1 acessar a op\u00E7\u00E3o reservar novamente, quando o seu momento de check-out chegar!")));
exports.default = BookAgain;
